import React from "react";
import { useTranslation } from "react-i18next";

import BarChart from "../BarChart";
import RegressionInfo from "./RegressionInfo";
import PieChart from "../PieChart";

function ExpectedValueBoard({
  data,
  quantitativeLabelsChecked,
  choiceLabelsChecked,
  table,
  selectedLabels,
  labelOpacity,
  setLabelOpacity,
  thumbnail,
  error,
  showValues,
  verticalBars,
  pieChart,
  sortDec,
}) {
  const categoricalRegression = window.categoricalRegression;
  const { t } = useTranslation();
  const noneOption = t("moodboards.placeholders.none");

  const options = [
    noneOption,
    ...table
      .filter((data) => data.id === choiceLabelsChecked[0].id)
      .flatMap(({ options }) => options),
  ];

  const analyses = quantitativeLabelsChecked.map(
    ({ id: quantitativeId, label: quantitativeLabel, question }) => {
      let labelCategories = [];
      data.forEach((beep) => {
        let quantitativeValue = null;
        let qualitativeValue = null;
        beep.table.forEach((row) => {
          if (row.id === quantitativeId) quantitativeValue = row.score;
          if (row.id === choiceLabelsChecked[0].id) {
            qualitativeValue = row.scoreArr.map((score) =>
              options.indexOf(score)
            );
          }
        });

        if (quantitativeValue !== null && qualitativeValue !== null) {
          let bits = new Array(options.length).fill(0);
          qualitativeValue.forEach((p) => {
            bits[p - 1] = 1;
          });
          labelCategories.push({
            quantitativeId,
            quantitativeLabel,
            quantitativeValue,
            qualitativeValue,
            bits,
          });
        }
      });
      //console.log(labelCategories);

      const valuesForCatReg = labelCategories.flatMap(
        ({ quantitativeValue }) => quantitativeValue
      );
      //console.log(valuesForCatReg);
      const indicesForCatReg = labelCategories.flatMap(({ bits }) => bits);
      //console.log(indicesForCatReg);
      return {
        ...categoricalRegression(valuesForCatReg, indicesForCatReg),
        id: quantitativeId,
        label: quantitativeLabel,
        question,
      };
    }
  );
  //console.log(analyses);
  let barchart = options.flatMap((option, index) => {
    let dataObj = {};

    analyses.forEach((analyse) => {
      // don't display "No chosen" if number of measurments (NM) is 0
      dataObj["name"] = option;

      let value = analyse.M[index];
      if (value > 100) value = 100;
      if (value < 0) value = 0;
      value = Math.round((value + Number.EPSILON) * 100) / 100;

      const errorMin = !isNaN(analyse.DELTAPLOW[index])
        ? analyse.DELTAPLOW[index] * 100
        : 0;
      const errorMax = !isNaN(analyse.DELTAPUP[index])
        ? analyse.DELTAPUP[index] * 100
        : 0;
      const error = [errorMin, errorMax];

      if (!isNaN(value)) {
        dataObj[analyse.id] = value;
        dataObj[`${analyse.id}$label`] = analyse.label;
        dataObj[analyse.id + "$error"] = error;
        dataObj[analyse.id + "$numberOfMeasurements"] = analyse.NM[index];
      }
    });
    return dataObj;
  });
  if (analyses?.[0]?.NM?.[0] === 0 || isNaN(analyses?.[0]?.NM?.[0]))
    barchart.shift();
  //console.log(barchart);
  return (
    <React.Fragment>
      {pieChart ? (
        <PieChart
          data={barchart}
          quantitativeLabelsChecked={quantitativeLabelsChecked}
          opacity={labelOpacity}
          height={!thumbnail ? 250 : 80}
          thumbnail={thumbnail}
          showValues={showValues}
          sortDec={sortDec}
        />
      ) : (
        <BarChart
          data={barchart}
          quantitativeLabelsChecked={quantitativeLabelsChecked}
          opacity={labelOpacity}
          height={!thumbnail ? 250 : 80}
          thumbnail={thumbnail}
          error={error}
          showValues={showValues}
          verticalBars={verticalBars}
          sortDec={sortDec}
        />
      )}
      {!thumbnail ? (
        <RegressionInfo
          category={choiceLabelsChecked[0]?.label}
          analyses={analyses}
        />
      ) : null}
    </React.Fragment>
  );
}

export default ExpectedValueBoard;
